import * as React from "react";
import { useSlideEditStore } from "@/state/slideEditStore";

export const SlideEditSidebar: React.FC = () => {
  const { sidebar, setSidebar } = useSlideEditStore();

  return (
    <div
      className={"border-r-2 border-gray-200"}
      style={{
        width: "20%",
        height: "100vh",
        position: "fixed",
        top: 0,
        left: 0,
        padding: "1rem",
        color: "white",
        boxSizing: "border-box",
        backgroundColor: "#002945",
      }}
    >
      <img src="assets/AlphaScript-logo.png" alt="" className="w-36 h-auto object-contain mb-8" />

      <ul className="mt-20" style={{ listStyle: "none", padding: 0 }}>
        <li
          style={{
            marginBottom: "0.5rem",
            marginLeft: "0.5rem",
            cursor: "pointer",
            color: sidebar === "slide-edit" ? "#FF5C35" : "#ffffff",
          }}
          onClick={() => setSidebar("slide-edit")}
        >
          Slide Edit
        </li>
        <li
          style={{
            marginBottom: "0.5rem",
            marginLeft: "0.5rem",
            cursor: "pointer",
            color: sidebar === "price-refresh" ? "#FF5C35" : "#ffffff",
          }}
          onClick={() => setSidebar("price-refresh")}
        >
          Price Refresh
        </li>
      </ul>
    </div>
  );
};
